import React from "react";
import { Field } from "redux-form";
import { FormattedMessage } from "react-intl";
import PropTypes from "prop-types";
import { TextInput } from "../../../../common/form";
import AccountSection from "./AccountSection";
class PayblesSection extends React.Component {
  renderProvinceFieldsForInsuranceTax() {
    return (
      <div className="sub-block">
        {this.props.provinces.map((item) => (
          <Field
            id={`insuranceTaxPayable${item.provinceCode}`}
            key={item.provinceCode}
            name={`accountProvinces['${item.accountProvinceId}'].insuranceTaxPayable`}
            component={TextInput}
            type="text"
            label={
              <FormattedMessage
                id={`common.provinces.${item.provinceCode.slice(-2)}`}
              />
            }
          />
        ))}
      </div>
    );
  }
  renderProvinceFieldsForMarkupTax() {
    return (
      <div className="sub-block">
        {this.props.provinces.map((item) => (
          <Field
            id={`salesTaxMarkupPayable${item.provinceCode}`}
            key={item.provinceCode}
            name={`accountProvinces['${item.accountProvinceId}'].salesTaxMarkupPayable`}
            component={TextInput}
            type="text"
            label={
              <FormattedMessage
                id={`common.provinces.${item.provinceCode.slice(-2)}`}
              />
            }
          />
        ))}
      </div>
    );
  }
  render() {
    return (
      <AccountSection
        title={<FormattedMessage id="admin.accounts.payables.heading" />}
      >
        {" "}
        <fieldset>
          <div>
            <div className="sub-fields">
              <Field
                id="generalPayableAccount"
                name="accountPayables.generalPayableAccount"
                component={TextInput}
                type="text"
                label={
                  <FormattedMessage id="admin.accounts.payables.generalAccount" />
                }
              />
              <Field
                id="customerReservations"
                name="accountPayables.customerReservations"
                component={TextInput}
                type="text"
                label={
                  <FormattedMessage id="admin.accounts.payables.reservedClients" />
                }
              />
            </div>
            <span className="section-heading">
              {" "}
              {
                <FormattedMessage id="admin.accounts.payables.insuranceTaxToPay" />
              }
            </span>
            {this.renderProvinceFieldsForInsuranceTax()}
            <span className="section-heading">
              {" "}
              {<FormattedMessage id="admin.accounts.payables.salesTaxToPay" />}
            </span>

            <div className="sub-block">
              <Field
                id="gstToPay"
                name="accountPayables.gstToPay"
                component={TextInput}
                type="text"
                label={<FormattedMessage id="admin.accounts.payables.gst" />}
              />
              <Field
                id="qstToPay"
                name="accountPayables.qstToPay"
                component={TextInput}
                type="text"
                label={<FormattedMessage id="admin.accounts.payables.qst" />}
              />
              <Field
                id="hstToPay"
                name="accountPayables.hstToPay"
                component={TextInput}
                type="text"
                label={<FormattedMessage id="admin.accounts.payables.hst" />}
              />
            </div>
            <span className="section-heading">
              {" "}
              {<FormattedMessage id="admin.accounts.payables.majorIncome" />}
            </span>
            <div className="sub-block">
              <Field
                id="commissionIncome"
                name="accountPayables.commissionIncome"
                component={TextInput}
                type="text"
                label={
                  <FormattedMessage id="admin.accounts.payables.commissions" />
                }
              />
              <Field
                id="freshIncome"
                name="accountPayables.freshIncome"
                component={TextInput}
                type="text"
                label={<FormattedMessage id="admin.accounts.payables.fees" />}
              />
              <Field
                id="increasedIncome"
                name="accountPayables.increasedIncome"
                component={TextInput}
                type="text"
                label={<FormattedMessage id="admin.accounts.payables.markup" />}
              />
            </div>
          </div>
          <div>
            <Field
              id="bonusToPay"
              name="accountPayables.bonusToPay"
              component={TextInput}
              type="text"
              label={<FormattedMessage id="admin.accounts.payables.premium" />}
            />
            <Field
              id="brokerCommission"
              name="accountPayables.brokerCommission"
              component={TextInput}
              type="text"
              label={
                <FormattedMessage id="admin.accounts.payables.brokerCommissions" />
              }
            />
            <span className="section-heading">
              {" "}
              {
                <FormattedMessage id="admin.accounts.payables.insuranceTaxMarkup" />
              }
            </span>
            {this.renderProvinceFieldsForMarkupTax()}
            <span className="section-heading">
              {" "}
              {<FormattedMessage id="admin.accounts.payables.salesTaxMarkup" />}
            </span>

            <div className="sub-block">
              <Field
                id="gstMarkUp"
                name="accountPayables.gstMarkUp"
                component={TextInput}
                type="text"
                label={<FormattedMessage id="admin.accounts.payables.gst" />}
              />
              <Field
                id="qstMarkUp"
                name="accountPayables.qstMarkUp"
                component={TextInput}
                type="text"
                label={<FormattedMessage id="admin.accounts.payables.qst" />}
              />
              <Field
                id="hstMarkUp"
                name="accountPayables.hstMarkUp"
                component={TextInput}
                type="text"
                label={<FormattedMessage id="admin.accounts.payables.hst" />}
              />
            </div>
          </div>{" "}
        </fieldset>
      </AccountSection>
    );
  }
}

PayblesSection.propTypes = {
  provinces: PropTypes.array,
};

export default PayblesSection;



// WEBPACK FOOTER //
// ./src/components/dashboard/admin/accounts/formSections/PayablesSection.js